import { ContentWrapperStyled } from './ContentWrapper.styled'

export const ContentWrapper = ({ children }) => <ContentWrapperStyled>{children}</ContentWrapperStyled>
